import { Navigate, Outlet, useParams } from 'react-router-dom';

const NumberManagement = () => {
    const { id } = useParams();
    return id ? <Outlet /> : <Navigate to="/numbers" />;
};

export default NumberManagement;
